import React, { ComponentType } from 'react';
import { Container } from '@cobalt/react-position-hook';

// wrapped position hook Container
export default function withContainer<Props>(WrappedComponent: ComponentType<Props>) {
  return (props: Props & JSX.IntrinsicAttributes) => {
    return (
      <Container style={{ width: '100%' }}>
        <WrappedComponent {...props}></WrappedComponent>
      </Container>
    );
  };
}
